import React from 'react'
import type { Catalog } from '../types/catalog'

type CatalogState = {
  catalog: Catalog | null
  loading: boolean
  error: string | null
}

const CatalogContext = React.createContext<CatalogState>({ catalog: null, loading: true, error: null })

export function CatalogProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = React.useState<CatalogState>({ catalog: null, loading: true, error: null })

  React.useEffect(() => {
    let cancelled = false
    async function load() {
      try {
        const res = await fetch('/catalog.json', { cache: 'no-cache' })
        if (!res.ok) throw new Error(`Failed to load catalog.json (${res.status})`)
        const data = (await res.json()) as Catalog
        if (!cancelled) setState({ catalog: data, loading: false, error: null })
      } catch (e: any) {
        if (!cancelled) setState({ catalog: null, loading: false, error: e?.message || 'Failed to load catalog' })
      }
    }
    // noinspection JSIgnoredPromiseFromCall
    load()

    return () => {
      cancelled = true
    }
  }, [])

  return <CatalogContext.Provider value={state}>{children}</CatalogContext.Provider>
}

export function useCatalog() {
  return React.useContext(CatalogContext)
}
